<template>
  <tr>
    <td class="mobile-up w-10">{{tabNumber + 1}}</td>
    <td class="team-name"><div class="inner">{{tabbleItem.team_name}} <br>
        <span class="lg:hidden md:hidden xl:hidden text-xs font-normal ">{{tabbleItem.city}}</span>
        </div>
    </td>
    <td class="xl:table-cell lg:table-cell md:table-cell sm:hidden xsm:hidden city">{{tabbleItem.city}}</td>
    <td class="xl:table-cell lg:table-cell md:table-cell sm:hidden xsm:hidden tour">{{tabbleItem['0']}}</td>
    <td class="xl:table-cell lg:table-cell md:table-cell sm:hidden xsm:hidden tour">{{tabbleItem['1']}}</td>
    <td class="xl:table-cell lg:table-cell md:table-cell sm:hidden xsm:hidden tour">{{tabbleItem['2']}}</td>
    <td class="xl:table-cell lg:table-cell md:table-cell sm:hidden xsm:hidden tour">{{tabbleItem['3']}}</td>
    <td class="xl:table-cell lg:table-cell md:table-cell sm:hidden xsm:hidden tour">{{tabbleItem['4']}}</td>
    <td class="xl:table-cell lg:table-cell md:table-cell sm:hidden xsm:hidden tour">{{tabbleItem['5']}}</td>
    <td class="xl:table-cell lg:table-cell md:table-cell sm:hidden xsm:hidden tour">{{tabbleItem['6']}}</td>
    <td class="xl:table-cell lg:table-cell md:table-cell sm:hidden xsm:hidden tour">{{tabbleItem['7']}}</td>
    <td class="xl:table-cell lg:table-cell md:table-cell sm:hidden xsm:hidden colored w-24 ">{{tabbleItem.total}}</td>
    <td @click="showResultModal" class="cursor-pointer outline-none underline sm:table-cell xl:hidden lg:hidden md:hidden colored mobile-up">{{tabbleItem.total}}</td>
  </tr>
</template>

<script>
export default {
  name: 'MozgoTableItem',
  props: {
    tabbleItem: {
      type: Object,
    },
    tabNumber: {
      type: Number,
    }
  },
  methods: {
    showResultModal() {
      this.$emit('showResultModal', {id: this.tabNumber})
    }
  }
};
</script>

<style scoped>
.tour {
  width: 44px;
}
tr {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid #979797;
}
td {

  padding: 5px;
  padding-top: 15px;
} 
.colored {
  color: #BD006C;
}
.inner {
  overflow: hidden;
    text-overflow: ellipsis;
    max-width: 340px;
}
.team-name {
  width: 350px;
    
}
.city {
  width: 250px;
}

@media screen and (min-width: 800px) and (max-width: 1000px)  {
.team-name {
  width: 180px;
    
}
.city {
  width: 120px;
}

}
@media screen and (min-width: 300px) and (max-width: 800px)  {
  tr {
    font-size: 12px !important;
    white-space: normal;
    
  }
  .team-name {
    width: 200px !important;
  }
  td.mobile-up {
    display: flex;
  }

}
</style>